import { createFileRoute } from "@tanstack/react-router";

import { DatasetPage } from "~/pages/dataset/dataset.page";

export const Route = createFileRoute("/_app/datasets/$datasetId")({
  component: DatasetPage,
});
